// AI-Generated Chess Pieces - The Only Piece Set
import aiWhiteKing from "@/assets/pieces/ai-white-king.png";
import aiWhiteQueen from "@/assets/pieces/ai-white-queen.png";
import aiWhiteRook from "@/assets/pieces/ai-white-rook.png";
import aiWhiteBishop from "@/assets/pieces/ai-white-bishop.png";
import aiWhiteKnight from "@/assets/pieces/ai-white-knight.png";
import aiWhitePawn from "@/assets/pieces/ai-white-pawn.png";
import aiBlackKing from "@/assets/pieces/ai-black-king.png";
import aiBlackQueen from "@/assets/pieces/ai-black-queen.png";
import aiBlackRook from "@/assets/pieces/ai-black-rook.png";
import aiBlackBishop from "@/assets/pieces/ai-black-bishop.png";
import aiBlackKnight from "@/assets/pieces/ai-black-knight.png";
import aiBlackPawn from "@/assets/pieces/ai-black-pawn.png";

// Single piece set - AI generated
export const pieceImages: { [key: string]: string } = {
  'K': aiWhiteKing,
  'Q': aiWhiteQueen,
  'R': aiWhiteRook,
  'B': aiWhiteBishop,
  'N': aiWhiteKnight,
  'P': aiWhitePawn,
  'k': aiBlackKing,
  'q': aiBlackQueen,
  'r': aiBlackRook,
  'b': aiBlackBishop,
  'n': aiBlackKnight,
  'p': aiBlackPawn
};

// Keep exports for backward compatibility
export const modernPieceImages = pieceImages;
export const classicPieceImages = pieceImages;

// Simplified - only one style now
export type PieceStyle = 'modern' | 'classic' | 'minimalist' | 'pixel' | 'default';

// Get piece images - always returns the same set now
export function getPieceImages(_style?: PieceStyle | string): { [key: string]: string } {
  return pieceImages;
}
